import * as apiCommon from '@/api/apiCommon'

// 失物招领
const apiName = '/webapi/lost_found'

// 获取失物
export function lostIndex(data) {
    return apiCommon.index(apiName + '/lostIndex', data)
}

//获取招领
export function foundIndex(data) {
    return apiCommon.index(apiName + '/foundIndex', data)
}

// 获取我的失物
export function myIndex(data) {
    return apiCommon.index(apiName + '/myIndex', data)
}

// 读取详情
export function read(data) {
    return apiCommon.index(apiName + '/read', data)
}

//获取失物类型
export function getLostType(data) {
    return apiCommon.index('/webapi/base_type/getLostType', data)
}

// 发布失物
export function save(data) {
    return apiCommon.save(apiName + '/save', data)
}